import { apiRequest } from './api';

export interface LikesSnapshotResponse {
  artists: number[];
  tracks: number[];
}

export interface LikeMutationResponse {
  liked: boolean;
  likes_count: number;
}

export async function fetchLikes(authToken: string) {
  return apiRequest<LikesSnapshotResponse>('/likes', {
    authToken,
  });
}

export async function likeArtist(artistId: number, authToken: string) {
  return apiRequest<LikeMutationResponse>(`/likes/artists/${artistId}`, {
    method: 'POST',
    authToken,
  });
}

export async function unlikeArtist(artistId: number, authToken: string) {
  return apiRequest<LikeMutationResponse>(`/likes/artists/${artistId}`, {
    method: 'DELETE',
    authToken,
  });
}

export async function likeTrack(trackId: number, authToken: string) {
  return apiRequest<LikeMutationResponse>(`/likes/tracks/${trackId}`, {
    method: 'POST',
    authToken,
  });
}

export async function unlikeTrack(trackId: number, authToken: string) {
  return apiRequest<LikeMutationResponse>(`/likes/tracks/${trackId}`, {
    method: 'DELETE',
    authToken,
  });
}
